import { render, staticRenderFns } from "./MediaLocalization.vue?vue&type=template&id=005b5842&scoped=true&"
import script from "./MediaLocalization.vue?vue&type=script&lang=js&"
export * from "./MediaLocalization.vue?vue&type=script&lang=js&"
import style0 from "./MediaLocalization.vue?vue&type=style&index=0&id=005b5842&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005b5842",
  null
  
)

export default component.exports